import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('msal-wrapper',[_c(VAppBar,{attrs:{"color":"primary","app":"","dense":""}},[_c(VBtn,{attrs:{"color":"primary","elevation":"0","dark":""},on:{"click":function($event){return _vm.redirectHome()}}},[_vm._v(" Strutt Invoicing ")])],1),_c(VMain,[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }